import React from 'react';

function ContactUs() {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 p-4">
      <h1 className="text-4xl font-bold mb-8 text-secondary-950">Contact Us</h1>
      <div className="bg-white shadow-md rounded p-8 w-full max-w-md">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-primary-500 mb-2">Phone</h2>
          <a href="tel:+918248199145" className="text-gray-800 text-lg hover:text-primary-500">
            +91 824 819 9145
          </a>
        </div>
        <div>
          <h2 className="text-2xl font-semibold text-primary-500 mb-2">Email</h2>
          <a href="mailto:contact@teamtechroofing.com" className="text-gray-800 text-lg hover:text-primary-500">
            contact@teamtechroofing.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
